// extracted by css-extract-rspack-plugin
export default {"docList":"FFkQBsTtc7cy_x39","docRow":"l1UFfhNaOvwfH2t9","docIcon":"PdX3DxDwcNQFfPbt","docLink":"WZApg9rlw0hPWjzx","docTime":"AUgFsJg5c_0Vf6Kn"};